import { type SyncRun } from '../../store/syncStore';
import { X } from 'lucide-react';

interface Props {
  run: SyncRun;
  onClose: () => void;
}

export default function SyncRunDetailModal({ run, onClose }: Props) {
  return (
    <div
      className="fixed inset-0 bg-black/50 flex items-center justify-center z-50"
      onClick={onClose}
    >
      <div
        className="bg-white dark:bg-gray-900 rounded-lg max-w-3xl w-full mx-4 max-h-[80vh] overflow-hidden flex flex-col"
        onClick={(e) => e.stopPropagation()}
      >
        <div className="flex items-center justify-between p-4 border-b border-gray-200 dark:border-gray-700">
          <h2 className="font-mono text-sm">{run.syncName} — {run.status}</h2>
          <button onClick={onClose}>
            <X className="w-5 h-5" />
          </button>
        </div>
        <div className="p-4 overflow-y-auto flex-1">
          <dl className="grid grid-cols-2 gap-2 text-sm mb-4">
            <dt className="text-gray-600">Started</dt>
            <dd>{run.startedAt ?? '—'}</dd>
            <dt className="text-gray-600">Finished</dt>
            <dd>{run.finishedAt ?? '—'}</dd>
            <dt className="text-gray-600">Duration</dt>
            <dd>{run.durationMs != null ? `${run.durationMs}ms` : '—'}</dd>
            <dt className="text-gray-600">Exit code</dt>
            <dd>{run.exitCode ?? '—'}</dd>
            {run.errorMessage && (
              <>
                <dt className="text-gray-600">Error</dt>
                <dd className="text-red-600">{run.errorMessage}</dd>
              </>
            )}
            {run.triggeredByUser && (
              <>
                <dt className="text-gray-600">Triggered by</dt>
                <dd>{run.triggeredByUser.displayName ?? run.triggeredByUser.email}</dd>
              </>
            )}
          </dl>
          {run.rowCounts && (
            <div className="mb-4">
              <div className="text-sm text-gray-600 mb-1">Row counts</div>
              <pre className="text-xs bg-gray-100 dark:bg-gray-800 p-2 rounded">
                {JSON.stringify(run.rowCounts, null, 2)}
              </pre>
            </div>
          )}
          {run.logTail && (
            <div>
              <div className="text-sm text-gray-600 mb-1">Log tail (last ~200 lines)</div>
              <pre className="text-xs bg-gray-900 text-gray-100 p-3 rounded overflow-x-auto whitespace-pre-wrap">
                {run.logTail}
              </pre>
            </div>
          )}
        </div>
      </div>
    </div>
  );
}
